import React from 'react';

import {Grid} from "@material-ui/core";
import Card from "@material-ui/core/Card";
import {makeStyles} from "@material-ui/core/styles";
import {getDateFromDateTime} from "../../../services/utils";
import { APP_DOMAIN_PREFIX } from "../../../environment";
const useStyles = makeStyles({
  root: {
    // maxWidth: 200,
    // margin: 10,
    // display:'flex',
    // flexDirection:'column',
    // alignItems:'center',
    padding: 10,
    display:'flex',
    flexDirection:'column',
    justifyContent:'space-around',
    // height:'100%'
    height: '-webkit-fill-available',
    // borderRadius:4,
// height:350
    // width: '100%',
    // background: 'red'
  },

});


function Index({product, item, ...props}) {
  const classes = useStyles();
  const productHandler = () => {
    props.history.push(`/editproduct/${2}`, {item})
  }
   let position = item?.imagePath?.search("userImages");
  let imageUrl = APP_DOMAIN_PREFIX + item.imagePath;
  if(position === -1)
   imageUrl = APP_DOMAIN_PREFIX + "/userImages/" + item.imagePath;

  return (
    <Grid item className='position-absolut' style={{maxWidth: 300,width:250,height:330,margin:10}}>
      <Card className={classes.root} >
        {/*<CardMedia*/}
        {/*  // className={classes.media}*/}
        {/*  image={mater}*/}
        {/*  title="Paella dish"*/}
        {/*/>*/}
        <img src={imageUrl} className='my-product-card-img' alt={''}/>
        <h2 className='text-capitalize mb-0 black-color '>{item.harvest || "noname"}</h2>
        <Grid container direction='row' alignItems='center' className='mb-10 '>
          <table className='light-black-color font-12'>
            <tr>
              <td>Price/Currency:</td>
              <td className='text-capitalize'>{item?.priceSetByVendor + " " + item?.currency}</td>
            </tr>
            {/*<tr>*/}
            {/*  <td>C:</td>*/}
            {/*  <td className='text-capitalize'>{item?.priceSetByVendor + " " + item?.currency}</td>*/}
            {/*</tr>*/}
            <tr>
              <td>Quantity:</td>
              <td className='text-capitalize'>{item?.qty} {item?.measure}</td>
            </tr>
            <tr>
              <td>{product ? 'Date' : 'Quantity'}:</td>
              <td className='text-capitalize'>{getDateFromDateTime(item?.purchaseDate)}</td>
            </tr>
          </table>
        </Grid>
        <Grid container direction='row'>
          <button className='buy-btn bg-green full-width white-color'
                  onClick={productHandler}
          >{product ? 'View / Edit Product' : 'bid for product'}</button>
        </Grid>
      </Card>
    </Grid>
  );
}

export default Index;
